import * as Accordion from '@radix-ui/react-accordion'
import type { ReactNode } from 'react'

interface GapAccordionProps {
  /** Currently expanded gap ids. Multi-select — independent per row. */
  value: string[]
  onValueChange: (next: string[]) => void
  children: ReactNode
}

/**
 * Thin wrapper over Radix Accordion in `multiple` mode so each gap row
 * can expand independently without collapsing siblings. Controlled value
 * lives on the page so external triggers (deep-link via `?gapId=...`,
 * gap-resolved auto-collapse) can drive state.
 */
export function GapAccordion({
  value,
  onValueChange,
  children,
}: GapAccordionProps) {
  return (
    <Accordion.Root
      type="multiple"
      value={value}
      onValueChange={onValueChange}
      className="flex flex-col gap-3"
      data-testid="gap-accordion"
    >
      {children}
    </Accordion.Root>
  )
}
